module.exports = __webpack_public_path__ + "static/media/d3_arrow.da9c53be.svg";